import { render, staticRenderFns } from "./Paginate.htm?vue&type=template&id=38f7d180&scoped=true&"
import script from "./Paginate.ts?vue&type=script&lang=js&"
export * from "./Paginate.ts?vue&type=script&lang=js&"
import style0 from "./Paginate.scss?vue&type=style&index=0&id=38f7d180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f7d180",
  null
  
)

export default component.exports